import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

 
export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    //prepare headers work need to be done
    prepareHeaders : async (headers, {getState, endpoint}) => {
      try{
        const token = getState().auth?.userDetail?.token;
        if (token) {
          if ( endpoint !== 'uploadFile') {
             headers.set('authorization', `Bearer ${token}`)
          }
     
        } else {
          headers.set('authorization', '')
        }
      } catch(err) {
        headers.set('authorization', '')
      }
      return headers
    },
  }),
  endpoints: () => ({}),
  tagTypes: [
    "getManager",
    "getStudent",
    "getEnrollment",
    "getEnrollmentReview",
    "getAdminDashboard",
    "getEnrollmentStatistics",
    "getLearnerProgress",
    "getResource",
    "getQualification",
    "getCourse",
    "getManageModule", 
    "getManageSubModule",
    "getQuestion",
    "getCertificateList",
    "getManageExam",
    "getLearningOutcome",
    "getLearningOutcomeDetail",
    "getVideo",
    "getArticle",
    "getCaseStudy",
    "getMessage",
    "getStudentMyCourse",
    "getStudentCourseTopic",
    "studentFinalQuizStart",
    "longQuestionsList",
    "longQuestionsResult",
    "getParticipants",
    "teacherQuestions",
    "getAdminParticipants",
    "getTask",
    "getTeacherQuestion",
    "getAdminGroup"
  ],
});
